import { render } from "./RedCat.svg?vue&type=template&id=3ad9a614"
const script = {}
script.render = render

export default script